/* =========================================================
   SENPAI DRIP — Quick add + quick peek
   Card bag button → half sheet (size/colour, Add to bag, Buy now).
   Swipe up / hint / handle / thumb / View full details → full sheet:
     gallery + the product page's own Info pills tabs (fetched in the
     background from that product's real page, so each template's
     text shows up). Falls back to the plain description.
   Full sheet: pull past the end, tap the title, or Open product page
     → product page. The photo you can SEE right now (the gallery
     slide if it's on screen, otherwise the header thumbnail) springs
     to fill the whole screen while the page loads (SDMorph.zoom in
     sd-motion.js). Reduced motion: plain navigation.
   Swipe down: full → half → closed.
   Perf: during a drag only transform/opacity are written, directly
   on the layers that move. Heavy DOM (gallery, tabs) is built when
   the phone is idle, never at the start of a swipe.
   Single-variant products add straight from the card.
   ========================================================= */
(function(){
  'use strict';
  if (window.SDQuickAdd) return;

  var reduced  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqMobile = window.matchMedia('(max-width:800px)');
  var EXT  = 80;    /* must match --qa-ext in sd-quick-add.css */
  var PULL = 110;   /* finger distance to open the product page */
  var HINT_KEY = 'sd_qa_hint';
  var COUNT_SEL = '[data-sd-cart-count], .cart-count-bubble span[aria-hidden], .cart-count, [data-cart-count]';
  var ICON_SEL  = '[data-sd-cart-icon], a[href$="/cart"]';
  var CARD_SEL  = '.sd-card, .sd-rec';
  var PROT_FALLBACK = [47319584669730, 47319584702498];
  var cache = {};
  var pages = {};
  var ui = null;

  var idle = window.requestIdleCallback
    ? function(fn){ window.requestIdleCallback(fn, { timeout: 1200 }); }
    : function(fn){ setTimeout(fn, 60); };

  /* ---------- helpers ---------- */
  function $(sel, ctx){ return (ctx || document).querySelector(sel); }
  function base(){ return ui ? ui.base : '/'; }
  function mobile(){ return mqMobile.matches; }
  function clamp(v, a, b){ return Math.max(a, Math.min(b, v)); }
  function modKey(e){ return e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1; }
  function esc(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }
  function uniq(arr){
    return arr.filter(function(v, i){ return v != null && arr.indexOf(v) === i; });
  }
  function isVisible(el){
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }
  /* how much of an element is actually on screen (0–1) */
  function onScreen(el){
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return 0;
    var w = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0);
    var h = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    if (w <= 0 || h <= 0) return 0;
    return (w * h) / (r.width * r.height);
  }
  function restart(el, cls){
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }
  function sized(src, w){
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  /* strip anything executable from HTML copied out of the product page */
  function clean(html){
    var t = document.createElement('template');
    t.innerHTML = html || '';
    t.content.querySelectorAll('script, style, link, meta, noscript').forEach(function(el){ el.remove(); });
    t.content.querySelectorAll('*').forEach(function(el){
      for (var k = el.attributes.length - 1; k >= 0; k--){
        if (/^on/i.test(el.attributes[k].name)) el.removeAttribute(el.attributes[k].name);
      }
    });
    var d = document.createElement('div');
    d.appendChild(t.content);
    return d.innerHTML;
  }

  /* real products only — the shipping-protection line never counts */
  function realCount(cart){
    var ids = (window.SDProtection && window.SDProtection.variants) || PROT_FALLBACK;
    var n = 0;
    cart.items.forEach(function(it){
      if (ids.indexOf(it.variant_id) === -1) n += it.quantity;
    });
    return n;
  }

  function fmt(cents, dec, thou, sep){
    var n = (cents / 100).toFixed(dec).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return n.length > 1 ? n[0] + sep + n[1] : n[0];
  }
  function money(cents){
    var format = (ui && ui.money) || '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, key){
      switch (key){
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  function swatchColor(value){
    var c = String(value).toLowerCase().replace(/[\s_-]+/g, '');
    return (window.CSS && CSS.supports && CSS.supports('color', c)) ? c : '';
  }

  function cardImg(card){
    if (!card) return null;
    var track = card.querySelector('[data-sd-track]');
    if (track && track.offsetParent){
      var imgs = track.querySelectorAll('img');
      return imgs[Math.round(track.scrollLeft / (track.clientWidth || 1))] || imgs[0];
    }
    return card.querySelector('.sd-card__frame img') || card.querySelector('.sd-rec__img img');
  }

  /* ---------- scroll lock ---------- */
  function lock(){
    var sb = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--sd-qa-sb', sb + 'px');
    document.documentElement.classList.add('sd-qa-lock');
  }
  function unlock(){
    document.documentElement.classList.remove('sd-qa-lock');
  }

  /* ---------- cart ---------- */
  function addVariant(id, qty){
    var body = { id: Number(id), quantity: qty || 1 };
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function'){
      try {
        body.sections = drawer.getSectionsToRender().map(function(s){ return s.id; });
        body.sections_url = window.location.pathname;
      } catch (e) {}
    }
    return fetch(base() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r){
      return r.json().then(function(j){
        if (!r.ok || j.status) throw j;
        return { data: j, drawer: drawer };
      });
    });
  }

  function refreshCount(){
    fetch(base() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var n = realCount(cart);
        document.querySelectorAll(COUNT_SEL).forEach(function(el){
          if (el.closest('.sd-qa')) return;
          if (el.closest('#cart-drawer')) return;
          el.textContent = n;
          el.hidden = false;
          if (!reduced) restart(el, 'sd-qa-pop');
        });
        document.dispatchEvent(new CustomEvent('sd:cart:updated', { detail: cart }));
      })
      .catch(function(){});
  }

  function openDrawer(res){
    document.dispatchEvent(new CustomEvent('sd:cart:added', { detail: res.data }));
    var openCart = ui ? ui.openCart : true;
    if (!openCart) return;

    if (window.SDCart && typeof window.SDCart.open === 'function'){
      window.SDCart.open();
      return;
    }
    var d = res.drawer;
    if (d && res.data.sections && typeof d.renderContents === 'function'){
      try {
        d.classList.remove('is-empty');
        d.renderContents(res.data);
      } catch (e) {}
    }
  }

  /* ---------- fly-to-cart ---------- */
  function fly(fromEl){
    if (reduced || !fromEl) return;
    var src = fromEl.currentSrc || fromEl.src;
    if (!src) return;

    var icons = document.querySelectorAll(ICON_SEL);
    var target = null;
    for (var i = 0; i < icons.length; i++){
      if (!icons[i].closest('.sd-qa') && isVisible(icons[i])){ target = icons[i]; break; }
    }
    if (!target) return;

    var a = fromEl.getBoundingClientRect();
    var b = target.getBoundingClientRect();
    var size = Math.min(a.width, a.height, 120);

    var ghost = document.createElement('img');
    ghost.src = src;
    ghost.alt = '';
    ghost.className = 'sd-qa-fly';
    ghost.style.left = (a.left + a.width / 2 - size / 2) + 'px';
    ghost.style.top = (a.top + a.height / 2 - size / 2) + 'px';
    ghost.style.width = size + 'px';
    ghost.style.height = size + 'px';
    document.body.appendChild(ghost);

    if (!ghost.animate){ ghost.remove(); return; }

    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);

    var anim = ghost.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + (dx * .45) + 'px,' + (dy * .45 - 80) + 'px) scale(.7) rotate(-8deg)', opacity: 1, offset: .45 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(6deg)', opacity: .2 }
    ], { duration: 850, easing: 'cubic-bezier(.5,0,.3,1)' });

    anim.onfinish = function(){
      ghost.remove();
      restart(target, 'sd-qa-pop');
    };
  }

  /* ---------- product data ---------- */
  function load(handle){
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(base() + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function(r){
      if (!r.ok) throw new Error('load failed');
      return r.json();
    }).then(function(p){
      cache[handle] = p;
      return p;
    });
  }

  /* the product page's own Info pills tabs (per-template text + fit_note) */
  function pageTabs(handle){
    if (pages[handle]) return Promise.resolve(pages[handle]);
    return fetch(base() + 'products/' + encodeURIComponent(handle), {
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin'
    }).then(function(r){
      if (!r.ok) throw new Error('page failed');
      return r.text();
    }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var tabs = [];

      var pills = doc.querySelector('[data-sd-pills]');
      if (pills){
        var btns = pills.querySelectorAll('.sd-pills__btn');
        var panes = pills.querySelectorAll('.sd-pills__pane');
        for (var i = 0; i < btns.length; i++){
          if (panes[i] && panes[i].innerHTML.trim()){
            tabs.push({ label: btns[i].textContent.trim(), html: panes[i].innerHTML });
          }
        }
      }
      if (!tabs.length){
        var d = doc.querySelector('.product-info-des, .product-accordion-card .collapsible-content');
        if (d && d.innerHTML.trim()) tabs.push({ label: 'Description', html: d.innerHTML });
      }
      pages[handle] = tabs;
      return tabs;
    });
  }

  /* ---------- sheet position (mobile) ----------
     The sheet is always full height (plus a hidden EXT below the
     screen) and moves only with translateY:
       0       = full      L.off = half      > L.off = closing
     The footer is counter-translated by the same amount on the same
     curve, so the buttons stay glued to the visible bottom edge. */
  function measure(){
    var full = ui.sheet.offsetHeight - EXT;
    var half = ui.details.offsetTop + ui.foot.offsetHeight;
    half = Math.max(240, Math.min(half, full * .9));
    ui.L.full = full;
    ui.L.half = half;
    ui.L.off = Math.max(0, full - half);
  }

  function clearInline(){
    [ui.sheet, ui.foot].forEach(function(el){
      el.style.transform = '';
      el.style.transition = '';
    });
    [ui.backdrop, ui.shade, ui.hint].forEach(function(el){
      if (el) el.style.opacity = '';
    });
  }

  function curve(kind){
    if (kind === 'none' || reduced) return 'none';
    if (kind === 'out')  return 'transform .42s cubic-bezier(.4,0,.2,1)';
    if (kind === 'soft') return 'transform .5s cubic-bezier(.16,1,.3,1)';
    return 'transform .62s cubic-bezier(.32,1.18,.52,1)';
  }

  function apply(y, kind){
    if (!mobile()) return;
    var L = ui.L;
    var t = curve(kind);
    var f = -clamp(y, 0, L.off);

    ui.sheet.style.transition = t;
    ui.foot.style.transition = t;
    ui.sheet.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    ui.foot.style.transform = 'translate3d(0,' + f.toFixed(1) + 'px,0)';

    var p = L.off ? clamp(1 - y / L.off, 0, 1) : 1;
    var fade = y <= L.off ? 1 : clamp(1 - (y - L.off) / Math.max(200, L.half), 0, 1);
    ui.backdrop.style.opacity = fade.toFixed(3);
    ui.shade.style.opacity = p.toFixed(3);
    ui.hint.style.opacity = clamp(1 - p * 1.8, 0, 1).toFixed(3);
    ui.y = y;
  }

  function place(kind){
    if (!mobile()){ clearInline(); return; }
    measure();
    apply(ui.state === 'full' ? 0 : ui.L.off, kind || 'soft');
  }

  function moreLabel(){
    var full = ui.state === 'full';
    ui.link.textContent = full ? ui.pageText : ui.moreText;
    ui.grab.setAttribute('aria-expanded', full ? 'true' : 'false');
    ui.grab.setAttribute('aria-label', full ? 'Collapse details' : 'Expand details');
  }

  function setState(s, kind){
    if (!ui || ui.going) return;
    ui.state = s;
    var full = s === 'full';
    ui.root.classList.toggle('is-full', full);
    moreLabel();
    resetPull();

    if (full){
      learned();
      /* rarely needed: built in the background already. Built after
         the spring if not, so the swipe itself never stalls */
      if (ui.product && ui.builtG !== ui.product.handle){
        setTimeout(function(){ if (ui.state === 'full') buildGallery(); }, reduced ? 0 : 520);
      }
      ensureAbout();
      requestAnimationFrame(glide);
    } else if (ui.scroll.scrollTop > 0){
      try { ui.scroll.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' }); }
      catch (e){ ui.scroll.scrollTop = 0; }
    }

    if (mobile()) apply(full ? 0 : ui.L.off, kind || 'spring');
    document.dispatchEvent(new CustomEvent('sd:qa:state', { detail: { state: s } }));
  }

  /* ---------- teach the gesture: a small lift on the first few opens ---------- */
  function hintCount(){
    try { return Number(localStorage.getItem(HINT_KEY) || 0); } catch (e){ return 9; }
  }
  function learned(){
    try { localStorage.setItem(HINT_KEY, '9'); } catch (e){}
  }
  function nudge(token){
    var n = hintCount();
    if (n >= 3 || reduced || !mobile()) return;
    try { localStorage.setItem(HINT_KEY, String(n + 1)); } catch (e){}

    setTimeout(function(){
      if (!ui || token !== ui.token || ui.touched || ui.state !== 'half') return;
      if (!ui.root.classList.contains('is-open')) return;
      apply(ui.L.off - 36, 'soft');
      setTimeout(function(){
        if (!ui || token !== ui.token || ui.touched || ui.state !== 'half') return;
        apply(ui.L.off, 'spring');
      }, 420);
    }, 1100);
  }

  /* ---------- full view: gallery ---------- */
  function buildGallery(){
    var p = ui.product;
    if (!p || ui.builtG === p.handle) return;
    ui.builtG = p.handle;

    var media = (p.media || []).filter(function(m){
      return m.media_type === 'image' && (m.src || (m.preview_image && m.preview_image.src));
    }).map(function(m){
      return { id: m.id, src: m.src || m.preview_image.src, alt: m.alt };
    });
    if (!media.length){
      media = (p.images || []).map(function(src){ return { id: null, src: src, alt: '' }; });
    }

    var many = media.length > 6;
    var slides = '', dots = '';
    media.forEach(function(m, i){
      slides += '<figure class="sd-qa__slide" style="--n:' + Math.min(i, 4) + '"' + (m.id ? ' data-media="' + m.id + '"' : '') + '>'
             +    '<img src="' + esc(sized(m.src, 800)) + '"'
             +    ' srcset="' + esc(sized(m.src, 500)) + ' 500w, ' + esc(sized(m.src, 800)) + ' 800w, ' + esc(sized(m.src, 1100)) + ' 1100w"'
             +    ' sizes="(min-width:801px) 420px, 80vw"'
             +    ' alt="' + esc(m.alt || p.title) + '"'
             +    ' loading="' + (i === 0 ? 'eager' : 'lazy') + '" decoding="async" draggable="false">'
             +  '</figure>';
      dots += '<span class="sd-qa__gdot' + (i === 0 ? ' on' : '') + '"></span>';
    });

    ui.gTotal = media.length;
    ui.track.innerHTML = slides;
    ui.gdots.innerHTML = (!many && media.length > 1) ? dots : '';
    ui.count.hidden = !many;
    ui.count.textContent = many ? '1 / ' + media.length : '';
    ui.track.scrollLeft = 0;
    ui.details.classList.add('is-built');
    syncGallery(false);
  }

  function galIndex(){
    var t = ui.track, slides = t.children;
    var c = t.scrollLeft + t.clientWidth / 2, best = 0, d = Infinity;
    for (var i = 0; i < slides.length; i++){
      var m = slides[i].offsetLeft + slides[i].offsetWidth / 2;
      var dd = Math.abs(m - c);
      if (dd < d){ d = dd; best = i; }
    }
    return best;
  }
  function paintDots(){
    var i = galIndex();
    if (ui.gTotal > 6){
      ui.count.textContent = (i + 1) + ' / ' + ui.gTotal;
      return;
    }
    var dots = ui.gdots.children;
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('on', k === i);
  }
  function goTo(i, smooth){
    var slides = ui.track.children;
    if (!slides.length) return;
    i = clamp(i, 0, slides.length - 1);
    var s = slides[i];
    var left = s.offsetLeft - (ui.track.clientWidth - s.offsetWidth) / 2;
    try { ui.track.scrollTo({ left: left, behavior: (smooth && !reduced) ? 'smooth' : 'auto' }); }
    catch (e){ ui.track.scrollLeft = left; }
  }
  /* jump the gallery to the picked colour's photo */
  function syncGallery(smooth){
    if (!ui.product || ui.builtG !== ui.product.handle) return;
    var v = ui.variant;
    var id = v && v.featured_media && v.featured_media.id;
    if (!id) return;
    var slides = ui.track.children;
    for (var i = 0; i < slides.length; i++){
      if (slides[i].getAttribute('data-media') === String(id)){ goTo(i, smooth); return; }
    }
  }

  /* ---------- full view: info tabs ---------- */
  function ensureAbout(){
    var p = ui.product;
    if (!p || ui.aboutFor === p.handle) return;
    var h = p.handle;
    ui.aboutFor = h;
    ui.about.hidden = false;
    ui.about.classList.add('is-loading');
    ui.tabs.innerHTML = '';
    ui.panes.innerHTML = '';

    pageTabs(h).then(function(tabs){
      if (ui.product && ui.product.handle === h) renderAbout(tabs);
    }).catch(function(){
      if (ui.product && ui.product.handle === h) renderAbout(null);
    });
  }

  function renderAbout(tabs){
    if (!tabs || !tabs.length){
      var d = ui.product && ui.product.description;
      tabs = d ? [{ label: 'Description', html: d }] : [];
    }
    ui.about.classList.remove('is-loading');
    ui.about.hidden = !tabs.length;
    if (!tabs.length) return;

    var t = '<span class="sd-qa__glider" aria-hidden="true"></span>', p = '';
    tabs.forEach(function(tab, i){
      t += '<button type="button" class="sd-qa__tab" role="tab" data-t="' + i + '"'
        +  ' aria-selected="' + (i === 0 ? 'true' : 'false') + '">' + esc(tab.label) + '</button>';
      p += '<div class="sd-qa__pane' + (i === 0 ? ' is-on' : '') + '" role="tabpanel" data-t="' + i + '">'
        +  clean(tab.html) + '</div>';
    });
    ui.tabs.innerHTML = t;
    ui.panes.innerHTML = p;
    requestAnimationFrame(glide);
  }

  function glide(){
    if (!ui) return;
    var g = ui.tabs.querySelector('.sd-qa__glider');
    var on = ui.tabs.querySelector('[aria-selected="true"]');
    if (!g || !on || !on.offsetWidth) return;
    g.style.transform = 'translateX(' + on.offsetLeft + 'px) scaleX(' + on.offsetWidth + ')';
  }

  function pickTab(btn){
    var i = btn.getAttribute('data-t');
    ui.tabs.querySelectorAll('.sd-qa__tab').forEach(function(b){
      b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
    });
    ui.panes.querySelectorAll('.sd-qa__pane').forEach(function(p){
      p.classList.toggle('is-on', p.getAttribute('data-t') === i);
    });
    glide();
    var left = btn.offsetLeft - (ui.tabs.clientWidth - btn.offsetWidth) / 2;
    try { ui.tabs.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' }); }
    catch (e){ ui.tabs.scrollLeft = left; }
  }

  function resetPull(){
    if (!ui) return;
    ui.pullFill.style.transform = '';
    ui.pull.classList.remove('is-armed');
    ui.pullLabel.textContent = ui.pullText;
    ui.root.classList.remove('is-pulling');
  }

  /* ---------- sheet ---------- */
  function say(text){
    if (!ui) return;
    ui.msg.textContent = text || '';
    if (ui.root.classList.contains('is-open') && !ui.root.classList.contains('is-dragging')) place('soft');
  }
  function setLabel(btn, text){
    var l = btn && btn.querySelector('.sd-qa__btn-label');
    if (l) l.textContent = text;
  }
  function bump(el, text){
    if (el.textContent === text) return;
    el.textContent = text;
    if (!reduced) restart(el, 'is-bump');
  }
  function shake(el){
    if (!reduced) restart(el, 'is-shake');
  }

  function swapImg(src){
    if (!src || ui.img.getAttribute('data-src') === src) return;
    ui.img.setAttribute('data-src', src);
    var url = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=320';
    ui.img.classList.add('is-swap');
    var pre = new Image();
    pre.onload = pre.onerror = function(){
      ui.img.src = url;
      ui.img.classList.remove('is-swap');
    };
    pre.src = url;
  }

  function render(p){
    ui.product = p;
    ui.title.textContent = p.title;

    var single = p.variants.length === 1 && /default title/i.test(p.variants[0].title);
    var start = p.variants.filter(function(v){ return v.available; })[0] || p.variants[0];
    ui.sel = start.options.slice();
    ui.names = [];

    var html = '';
    if (!single){
      p.options.forEach(function(opt, i){
        var name = typeof opt === 'string' ? opt : opt.name;
        var values = (opt && opt.values) || uniq(p.variants.map(function(v){ return v.options[i]; }));
        var isColor = /colou?r/i.test(name);
        ui.names[i] = name;

        html += '<fieldset class="sd-qa__group" data-i="' + i + '" style="--gi:' + i + '">'
             +    '<legend class="sd-qa__label">' + esc(name) + '<span class="sd-qa__picked" data-picked></span></legend>'
             +    '<div class="sd-qa__pills">';

        values.forEach(function(v, n){
          var sw = isColor ? swatchColor(v) : '';
          if (sw){
            html += '<button type="button" class="sd-qa__swatch" data-v="' + esc(v) + '"'
                 +  ' style="--n:' + n + ';--sw:' + sw + '"'
                 +  ' aria-label="' + esc(v) + '" title="' + esc(v) + '" aria-pressed="false">'
                 +  '<span class="sd-qa__sw"></span></button>';
          } else {
            html += '<button type="button" class="sd-qa__pill" data-v="' + esc(v) + '"'
                 +  ' style="--n:' + n + '" aria-pressed="false">' + esc(v) + '</button>';
          }
        });

        html += '</div></fieldset>';
      });
    }

    ui.opts.innerHTML = html;
    ui.opts.hidden = single;
    refresh();
    if (ui.state === 'full'){ buildGallery(); ensureAbout(); }
  }

  function refresh(){
    var p = ui.product;
    if (!p) return;

    ui.variant = p.variants.filter(function(v){
      return v.options.every(function(o, k){ return o === ui.sel[k]; });
    })[0] || null;

    ui.opts.querySelectorAll('[data-i]').forEach(function(g){
      var i = Number(g.getAttribute('data-i'));
      var picked = g.querySelector('[data-picked]');
      if (picked) picked.textContent = ui.sel[i] || '';

      g.querySelectorAll('[data-v]').forEach(function(b){
        var v = b.getAttribute('data-v');
        var on = v === ui.sel[i];
        var ok = p.variants.some(function(x){
          if (!x.available || x.options[i] !== v) return false;
          for (var k = 0; k < ui.sel.length; k++){
            if (k !== i && x.options[k] !== ui.sel[k]) return false;
          }
          return true;
        });
        b.classList.toggle('is-on', on);
        b.classList.toggle('is-out', !ok);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-disabled', ok ? 'false' : 'true');
      });
    });

    var v = ui.variant;
    var price = v ? v.price : p.price;
    var cmp = v ? v.compare_at_price : p.compare_at_price;
    bump(ui.price, money(price));
    ui.compare.textContent = cmp && cmp > price ? money(cmp) : '';

    var img = (v && v.featured_image && v.featured_image.src) || p.featured_image;
    swapImg(img);

    var can = !!(v && v.available);
    setLabel(ui.add, !v ? 'Unavailable' : (v.available ? ui.addText : 'Sold out'));
    ui.add.disabled = !can;
    if (ui.buy) ui.buy.disabled = !can;

    var url = base() + 'products/' + p.handle + (v ? '?variant=' + v.id : '');
    ui.link.href = url;
    ui.title.href = url;
    syncGallery(true);
  }

  function onPick(e){
    var b = e.target.closest('[data-v]');
    if (!b) return;
    var i = Number(b.closest('[data-i]').getAttribute('data-i'));
    var v = b.getAttribute('data-v');

    if (b.classList.contains('is-out')){
      shake(b);
      say((ui.names[i] || '') + ' ' + v + ' is sold out' + (ui.sel.length > 1 ? ' in this combination.' : '.'));
      return;
    }
    ui.sel[i] = v;
    say('');
    refresh();
  }

  function open(trigger, handle){
    if (!ui) return;
    var token = ++ui.token;

    ui.trigger = trigger;
    ui.product = null;
    ui.variant = null;
    ui.busy = false;
    ui.going = false;
    ui.touched = false;
    ui.builtG = null;
    ui.aboutFor = null;
    ui.gTotal = 0;
    ui.state = 'half';
    ui.msg.textContent = '';
    ui.opts.innerHTML = '';
    ui.price.textContent = '';
    ui.compare.textContent = '';
    ui.title.textContent = '';
    ui.img.removeAttribute('data-src');
    ui.track.innerHTML = '';
    ui.gdots.innerHTML = '';
    ui.count.hidden = true;
    ui.tabs.innerHTML = '';
    ui.panes.innerHTML = '';
    ui.about.hidden = false;
    ui.about.classList.remove('is-loading');
    ui.details.classList.remove('is-built');
    ui.link.href = base() + 'products/' + handle;
    ui.title.href = ui.link.href;
    ui.root.classList.remove('is-full', 'is-expanding', 'is-dragging', 'is-going', 'is-pulling');
    ui.root.style.removeProperty('--sd-qa-rise');
    moreLabel();
    resetPull();
    [ui.add, ui.buy].forEach(function(b){ if (b) b.classList.remove('is-busy', 'is-done'); });

    /* prefill from the card so the sheet never opens blank */
    var card = trigger && trigger.closest(CARD_SEL);
    if (card){
      var ci = cardImg(card);
      var ct = card.querySelector('.sd-card__title, .sd-rec__title');
      if (ci) ui.img.src = ci.currentSrc || ci.src;
      if (ct) ui.title.textContent = ct.textContent.trim();
    }

    /* peek mode: opened from the garment switcher */
    var sw = trigger && trigger.closest('[data-sd-sw-item]');
    ui.peek = !!sw;
    ui.root.classList.toggle('is-peek', ui.peek);
    if (ui.eyebrow) ui.eyebrow.textContent = ui.peek ? ui.peekText : ui.eyebrowText;
    if (sw){
      var si = sw.querySelector('img');
      var st = sw.getAttribute('data-sd-sw-title');
      if (si) ui.img.src = si.currentSrc || si.src;
      if (st) ui.title.textContent = st;
    }

    ui.root.hidden = false;
    ui.root.classList.add('is-loading');
    ui.root.classList.remove('is-ready');
    ui.scroll.scrollTop = 0;
    lock();

    /* park the sheet just below the screen, then spring it up */
    clearInline();
    if (mobile()){
      measure();
      apply(ui.L.full + EXT + 40, 'none');
      void ui.sheet.offsetWidth;
    }
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        if (token !== ui.token) return;
        ui.root.classList.add('is-open');
        place('spring');
      });
    });

    load(handle).then(function(p){
      if (token !== ui.token) return;
      render(p);
      ui.root.classList.remove('is-loading');
      requestAnimationFrame(function(){
        if (token !== ui.token) return;
        ui.root.classList.add('is-ready');
        if (ui.root.classList.contains('is-open') && !ui.root.classList.contains('is-dragging')) place('soft');
      });

      /* heavy work waits until the open spring is done and the phone is idle */
      setTimeout(function(){
        idle(function(){
          if (token !== ui.token) return;
          buildGallery();
          ensureAbout();
        });
      }, 700);
      nudge(token);

      try { ui.closeBtn.focus({ preventScroll: true }); } catch (e) {}
      document.dispatchEvent(new CustomEvent('sd:qa:ready', {
        detail: { product: p, variant: ui.variant, peek: ui.peek, url: ui.link.href }
      }));
    }).catch(function(){
      window.location.href = base() + 'products/' + handle;
    });
  }

  function close(){
    if (!ui || !ui.root.classList.contains('is-open')) return;
    if (ui.going || ui.root.classList.contains('is-expanding')) return;
    ui.token++;
    var root = ui.root;
    root.classList.remove('is-open', 'is-ready', 'is-dragging', 'is-pulling');
    if (mobile()) apply(ui.L.full + EXT + 40, 'out');
    unlock();
    setTimeout(function(){
      if (root.classList.contains('is-open')) return;
      root.hidden = true;
      root.classList.remove('is-peek', 'is-full');
      root.style.removeProperty('--sd-qa-rise');
      if (ui){
        clearInline();
        ui.state = 'half';
        ui.peek = false;
        moreLabel();
        resetPull();
        if (ui.eyebrow) ui.eyebrow.textContent = ui.eyebrowText;
      }
    }, reduced ? 0 : 460);
    if (ui.trigger && ui.trigger.isConnected){
      try { ui.trigger.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  /* garment-switcher peek → sd-switcher.js animates the page open */
  function expand(){
    if (!ui) return;
    var url = ui.link.href;
    var ev = new CustomEvent('sd:qa:expand', {
      cancelable: true,
      detail: { url: url, product: ui.product, variant: ui.variant, sheet: ui.sheet, img: ui.img }
    });
    if (document.dispatchEvent(ev)) window.location.href = url;
  }

  /* The photo the shopper can SEE in the sheet right now:
     1. the centred gallery slide, if at least half of it is on screen
        and it has loaded
     2. otherwise the header thumbnail (always on screen) */
  function sheetShot(){
    if (ui.state === 'full' && ui.product && ui.builtG === ui.product.handle && ui.track.children.length){
      var slide = ui.track.children[galIndex()];
      var im = slide && slide.querySelector('img');
      if (im && im.complete && im.naturalWidth && onScreen(im) >= 0.5) return im;
    }
    return ui.img;
  }

  /* To the product page.
     Zoom available: the photo you can see springs to fill the screen
       the instant you let go, and the page starts loading immediately.
       The sheet stays put underneath — the photo covers it.
     Reduced motion / no zoom: the sheet stretches edge to edge,
       corners square off, fades into the page (original behaviour). */
  function go(){
    if (!ui || ui.going) return;
    if (ui.peek){ expand(); return; }
    var url = ui.link.href;
    var M = window.SDMorph;
    learned();

    if (M && M.can){
      ui.going = true;
      M.zoom ? M.zoom(sheetShot()) : M.name(sheetShot());
      document.dispatchEvent(new CustomEvent('sd:qa:go', { detail: { url: url, product: ui.product } }));
      window.location.href = url;
      return;
    }

    ui.going = true;
    ui.root.classList.add('is-going');
    if (mobile()) apply(0, 'soft');
    document.dispatchEvent(new CustomEvent('sd:qa:go', { detail: { url: url, product: ui.product } }));
    setTimeout(function(){ window.location.href = url; }, reduced ? 0 : 460);
  }

  function submit(buyNow){
    var v = ui.variant;
    if (!v || !v.available || ui.busy) return;
    ui.busy = true;
    say('');

    var btn = buyNow ? ui.buy : ui.add;
    btn.classList.add('is-busy');

    addVariant(v.id, 1).then(function(res){
      if (buyNow){
        window.location.href = base() + 'checkout';
        return;
      }
      btn.classList.remove('is-busy');
      btn.classList.add('is-done');
      fly(ui.img);
      refreshCount();
      setTimeout(function(){
        close();
        btn.classList.remove('is-done');
        ui.busy = false;
        openDrawer(res);
      }, reduced ? 350 : 900);
    }).catch(function(err){
      btn.classList.remove('is-busy');
      ui.busy = false;
      say((err && (err.description || err.message)) || "Couldn't add that. Try again.");
      shake(btn);
    });
  }

  /* ---------- swipe (mobile) ----------
     Half: the whole sheet is the handle. Up → full, down → close.
     Full: down → half/close when scrolled to the top (or dragging the
           header / buttons). Up at the very bottom → pull to open the
           product page. Anything else scrolls the content normally.
     Release projects the finger's speed forward and snaps.
     Sideways = gallery / tabs. Taps are untouched (8px slop). */
  function drag(){
    var SLOP = 8;
    var sx = 0, sy = 0, y0 = 0;
    var mode = null, tracking = false, handle = false, armed = false;
    var lastY = 0, lastT = 0, vel = 0;

    function rub(u){ return u < 120 ? u * .35 : 42 + (u - 120) * .1; }
    function atTop(){ return ui.scroll.scrollTop <= 0; }
    function atBottom(){
      var s = ui.scroll;
      return s.scrollTop + s.clientHeight >= s.scrollHeight - 2;
    }

    ui.sheet.addEventListener('touchstart', function(e){
      if (!mobile() || e.touches.length !== 1 || ui.going) return;
      if (!ui.root.classList.contains('is-open') || ui.root.classList.contains('is-expanding')) return;
      var t = e.touches[0];
      ui.touched = true;
      sx = t.clientX;
      sy = t.clientY;
      mode = null;
      tracking = true;
      armed = false;
      vel = 0;
      lastY = sy;
      lastT = Date.now();
      handle = !!(e.target.closest && e.target.closest('.sd-qa__top, .sd-qa__foot'));
    }, { passive: true });

    ui.sheet.addEventListener('touchmove', function(e){
      if (!tracking) return;
      var t = e.touches[0];
      var mx = t.clientX - sx;
      var my = t.clientY - sy;

      if (!mode){
        if (Math.abs(mx) < SLOP && Math.abs(my) < SLOP) return;
        if (Math.abs(mx) > Math.abs(my)){ tracking = false; return; }

        if (ui.state !== 'full') mode = 'sheet';
        else if (my > 0 && (handle || atTop())) mode = 'sheet';
        else if (my < 0 && atBottom()) mode = 'pull';
        else { tracking = false; return; }   /* let the content scroll */

        sy = t.clientY;                       /* start from here, no jump */
        y0 = ui.state === 'full' ? 0 : ui.L.off;
        ui.root.classList.add('is-dragging');
        if (mode === 'pull') ui.root.classList.add('is-pulling');
      }

      e.preventDefault();
      var now = Date.now();
      var dt = now - lastT;
      if (dt > 0) vel = vel * .2 + ((t.clientY - lastY) / dt) * .8;
      lastY = t.clientY;
      lastT = now;

      var raw = t.clientY - sy;

      if (mode === 'pull'){
        var d = Math.max(0, -raw);
        apply(-rub(d), 'none');
        var k = Math.min(1, d / PULL);
        ui.pullFill.style.transform = 'scaleX(' + k.toFixed(3) + ')';
        if ((k >= 1) !== armed){
          armed = k >= 1;
          ui.pull.classList.toggle('is-armed', armed);
          ui.pullLabel.textContent = armed ? ui.releaseText : ui.pullText;
        }
        return;
      }

      var y = y0 + raw;
      if (y < 0) y = -rub(-y);                /* rubber-band past full */
      apply(y, 'none');
    }, { passive: false });

    function end(){
      if (!tracking) return;
      tracking = false;
      if (!mode) return;
      var m = mode;
      mode = null;
      ui.root.classList.remove('is-dragging');

      if (m === 'pull'){
        ui.root.classList.remove('is-pulling');
        if (armed){ go(); }
        else { apply(0, 'spring'); resetPull(); }
        return;
      }

      if (Date.now() - lastT > 90) vel = 0;   /* finger paused before lifting */
      var L = ui.L;
      var proj = ui.y + vel * 200;

      if (proj < L.off * .5) setState('full');
      else if (proj < L.off + Math.max(110, L.half * .35)) setState('half');
      else close();
    }
    ui.sheet.addEventListener('touchend', end);
    ui.sheet.addEventListener('touchcancel', end);
  }

  /* ---------- direct add (single-variant products) ---------- */
  function quickCard(btn){
    if (btn.classList.contains('is-busy')) return;
    var handle = btn.getAttribute('data-sd-qa');
    btn.classList.add('is-busy');

    addVariant(btn.getAttribute('data-sd-qa-variant'), 1).then(function(res){
      btn.classList.remove('is-busy');
      btn.classList.add('is-done');
      fly(cardImg(btn.closest(CARD_SEL)));
      refreshCount();
      openDrawer(res);
      setTimeout(function(){ btn.classList.remove('is-done'); }, 1600);
    }).catch(function(){
      btn.classList.remove('is-busy');
      if (ui) open(btn, handle);
      else window.location.href = base() + 'products/' + handle;
    });
  }

  /* ---------- bind ---------- */
  function bind(){
    var root = $('[data-sd-qa-root]');
    if (!root){ ui = null; return; }
    if (root.__sdqa) return;
    root.__sdqa = true;

    var pull = $('[data-sd-qa-pull]', root);

    ui = {
      root: root,
      base: (root.getAttribute('data-root') || '/').replace(/\/?$/, '/'),
      money: root.getAttribute('data-money') || '${{amount}}',
      openCart: root.getAttribute('data-open-cart') === '1',
      backdrop: $('.sd-qa__backdrop', root),
      shade: $('.sd-qa__shade', root),
      sheet: $('.sd-qa__sheet', root),
      scroll: $('[data-sd-qa-scroll]', root),
      foot: $('[data-sd-qa-foot]', root),
      hint: $('[data-sd-qa-hint]', root),
      details: $('[data-sd-qa-details]', root),
      track: $('[data-sd-qa-track]', root),
      count: $('[data-sd-qa-count]', root),
      gdots: $('[data-sd-qa-gdots]', root),
      about: $('[data-sd-qa-about]', root),
      tabs: $('[data-sd-qa-tabs]', root),
      panes: $('[data-sd-qa-panes]', root),
      pull: pull,
      pullFill: $('[data-sd-qa-pull-fill]', root),
      pullLabel: $('[data-sd-qa-pull-label]', root),
      grab: $('[data-sd-qa-grab]', root),
      prev: $('[data-sd-qa-prev]', root),
      next: $('[data-sd-qa-next]', root),
      closeBtn: $('.sd-qa__close', root),
      eyebrow: $('.sd-qa__eyebrow', root),
      img: $('[data-sd-qa-img]', root),
      title: $('[data-sd-qa-title]', root),
      price: $('[data-sd-qa-price]', root),
      compare: $('[data-sd-qa-compare]', root),
      opts: $('[data-sd-qa-opts]', root),
      msg: $('[data-sd-qa-msg]', root),
      add: $('[data-sd-qa-add]', root),
      buy: $('[data-sd-qa-buy]', root),
      link: $('[data-sd-qa-link]', root),
      addText: 'Add to bag',
      eyebrowText: '',
      peekText: 'Quick look',
      moreText: 'View full details',
      pageText: 'Open product page',
      pullText: 'Keep pulling to open product page',
      releaseText: 'Release to open',
      product: null, variant: null, sel: [], names: [],
      trigger: null, busy: false, peek: false, going: false, touched: false,
      token: 0, state: 'half', builtG: null, aboutFor: null, gTotal: 0, y: 0,
      L: { full: 0, half: 0, off: 0 }
    };
    ui.addText = ui.add.getAttribute('data-label') || ui.addText;
    ui.eyebrowText = ui.eyebrow ? ui.eyebrow.textContent : '';
    ui.moreText = ui.link.getAttribute('data-more') || ui.moreText;
    ui.pageText = ui.link.getAttribute('data-page') || ui.pageText;
    ui.pullText = pull.getAttribute('data-idle') || ui.pullText;
    ui.releaseText = pull.getAttribute('data-armed') || ui.releaseText;

    root.addEventListener('click', function(e){
      if (e.target.closest('[data-sd-qa-close]')){ close(); return; }

      /* title → product page */
      if (e.target.closest('[data-sd-qa-go]')){
        if (!modKey(e)){ e.preventDefault(); go(); }
        return;
      }
      /* half: expand in place. full: product page */
      if (e.target.closest('[data-sd-qa-link]')){
        if (!modKey(e)){
          e.preventDefault();
          if (ui.state !== 'full') setState('full');
          else go();
        }
        return;
      }
      if (e.target.closest('[data-sd-qa-grab]')){
        setState(ui.state === 'full' ? 'half' : 'full');
        return;
      }
      if (e.target.closest('[data-sd-qa-hint]')){ setState('full'); return; }
      if (ui.state !== 'full' && e.target.closest('[data-sd-qa-thumb]')){ setState('full'); return; }

      var tab = e.target.closest('.sd-qa__tab');
      if (tab){ pickTab(tab); return; }
    });

    ui.opts.addEventListener('click', onPick);
    ui.add.addEventListener('click', function(){ submit(false); });
    if (ui.buy) ui.buy.addEventListener('click', function(){ submit(true); });

    /* gallery dots / counter + desktop arrows */
    var dotRaf = 0;
    ui.track.addEventListener('scroll', function(){
      if (dotRaf) return;
      dotRaf = requestAnimationFrame(function(){ dotRaf = 0; paintDots(); });
    }, { passive: true });
    if (ui.prev) ui.prev.addEventListener('click', function(){ goTo(galIndex() - 1, true); });
    if (ui.next) ui.next.addEventListener('click', function(){ goTo(galIndex() + 1, true); });

    /* keep the half height right on rotate / resize / breakpoint change */
    function reflow(){
      if (!ui || ui.going || !ui.root.classList.contains('is-open')) return;
      place('none');
      glide();
    }
    window.addEventListener('resize', reflow);
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', reflow);
    else if (mqMobile.addListener) mqMobile.addListener(reflow);

    /* Back from the product page (page cache): don't come back to a veil */
    window.addEventListener('pageshow', function(e){
      if (!ui || !ui.going) return;
      ui.going = false;
      ui.token++;
      ui.root.classList.remove('is-going', 'is-open', 'is-ready', 'is-full', 'is-dragging', 'is-pulling');
      ui.root.hidden = true;
      clearInline();
      unlock();
      ui.state = 'half';
      moreLabel();
      resetPull();
    });

    drag();
  }

  /* card + switcher buttons (delegated, so re-rendered markup works too) */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-sd-qa]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    if (btn.getAttribute('data-sd-qa-single') === 'true'){
      quickCard(btn);
    } else if (ui){
      open(btn, btn.getAttribute('data-sd-qa'));
    } else {
      window.location.href = base() + 'products/' + btn.getAttribute('data-sd-qa');
    }
  });

  /* Esc + focus trap */
  document.addEventListener('keydown', function(e){
    if (!ui || !ui.root.classList.contains('is-open')) return;
    if (e.key === 'Escape'){ close(); return; }
    if (e.key !== 'Tab') return;

    var f = Array.prototype.filter.call(
      ui.sheet.querySelectorAll('button:not([disabled]), a[href]'),
      function(el){ return el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });

  document.addEventListener('shopify:section:load', bind);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();

  window.SDQuickAdd = {
    open: function(handle, trigger){ bind(); open(trigger || null, handle); },
    close: close,
    expand: expand,
    go: go,
    full: function(){ setState('full'); },
    half: function(){ setState('half'); }
  };
})();